export default __webpack_public_path__ + "files/FP7_Financial_Instruments_Loans.docx";